<template>
  <div>
    <h1 class="mb-4">Transactions Report</h1>

    <b-row>
      <b-col cols="4">
        <BaseSelector v-model="filters.status"
                      :v="$v.filters.status"
                      label="Transfer Status"
                      slug="status"
                      :options=statusOptions
                      setId="status"
        />
      </b-col>
<!--      <b-col cols="4">-->
<!--        <BaseTextInput v-model="filters.applicationNumber"-->
<!--                       :v="$v.filters.applicationNumber"-->
<!--                       slug="appNumber"-->
<!--                       label="Application Number"-->
<!--                       setId="appNumber"-->
<!--        />-->
<!--      </b-col>-->
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-button type="button" variant="success" class="mr-3" @click="search">Search</b-button>
        <b-button type="button" variant="secondary" class="mr-3" @click="clear">Clear</b-button>
        <b-button type="button" variant="primary" @click="retryAll">
          Retry all with errors
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table hover small responsive show-empty
                 class="sr-caption"
                 id="applications"
                 :fields="fields"
                 :items="records"
                 :busy="isLoading"
                 :current-page="currentPage"
                 :per-page="0"
                 primary-key="id"
                 label-sort-asc=""
                 label-sort-desc=""
                 @sort-changed="search"
                 caption="Perceptive Content Document Transfer table.  To sort the data in this table by a specific column,
                 go to the appropriate column header cell and use enter to sort the data ascending.  Use enter again to sort
                 descending.">

          <template v-slot:empty="scope">
            <p>No records found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle spinner-margin"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>

          <template v-slot:cell(actions)="row">
            <b-button size="sm" v-if="row.item.status === 'ERROR'" @click="retry(row.item.id)">
              Retry
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="fill"
                size="sm"
                class="my-0"
                @change="search(false, $event)"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="2" offset="10">
        <b-form-group
                label="Per Page:"
                label-size="sm"
                label-for="perPageSelect"
                class="custom-control-inline mr-3"
        >
          <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  @change="search(true)"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { required } from 'vuelidate/lib/validators'
import ConfigService from "@/services/ConfigService";

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {
  data: () => ({
    fields: [
      {key: 'applicationNumber', label: 'Number'},
      {key: 'status', label: 'Status'},
      {key: 'hfid', label: 'HFID'},
      {key: 'lastModifiedDate', label: 'Last Modified'},
      {key: 'actions', label: 'Actions'}
    ],
    selected: {},
    perPage: 10,
    currentPage: 1,
    totalRows: 1,
    pageOptions: [5, 10, 15, 20],
    isLoading: false,
    statusOptions: [
      { text: "Any", value:"" },
      { text: "Pending", value:"PENDING" },
      { text: "Processed", value:"PROCESSED" },
      { text: "Error", value:"ERROR" },
    ],
    records: [],
    filters: {
      status: "ERROR",
      applicationNumber: null,
    }
  }),

  watch: {
    records() {
      this.isLoading = false
    },
  },

  created () {
    document.title = "Transaction Report - Body Art"
    this.search()
  },

  methods: {
    clear() {
      this.filters.status = "ERROR"
      this.filters.applicationNumber = null
      this.search()
    },
    search(reset, $event) {
      if (reset === true) {
        this.currentPage = 1
      }
      let payload = {
        applicationNumber: (this.filters.applicationNumber && this.filters.applicationNumber.trim().length > 0)
                ? this.filters.applicationNumber : null,
        status: this.filters.status && this.filters.status.trim().length > 0 ? this.filters.status : null,
        page: !$event ? this.currentPage -1 : $event -1,
        size: this.perPage
      }
      axios.get(ConfigService.getApiUrl() + `/api/uploadrequests`, { params: payload })
              .then(response => {
                this.records = response.data.content
                this.totalRows = response.data.totalElements
              })
    },
    retry(id) {
      axios.put(ConfigService.getApiUrl() + `/api/uploadrequests/`+ id + '/reschedule')
              .then(response => {
                this.showRootToast("Success", "Item Scheduled to Retry Transfer to Perceptive Content", "success")
                this.search()
              })
    },
    retryAll() {
      axios.put(ConfigService.getApiUrl() + `/api/uploadrequests/rescheduleAllError`)
              .then(response => {
                this.showRootToast("Success", "All Items in Error Status Scheduled to Retry Transfer to Perceptive Content", "success")
                this.search()
              })
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
  },

  validations: {
    filters: {
      status: { required: false },
      applicationNumber: { required: false },
    },
  },
}
</script>